import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class GlobalmodalController {
  constructor(
    $http,
    $state,
    $stateParams,
    $scope,
    AuthService,
    EventsService,
    SecurityService,
    $rootScope,
    $localStorage,
    ngProgressFactory,
    $timeout,
    $cookies,
    TrackingService
  ) {
    this.name = "globalmodal";
    this.$http = $http;
    this.$auth = AuthService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$progress = ngProgressFactory.createInstance();
    this.$events = EventsService;
    this.$localStorage = $localStorage;
    this.$scope = $scope;
    this.$security = SecurityService;
    this.$cookies = $cookies;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 0;
    this.isLazyUser = true;
    this.errorMessage = {status: false, message: null};
    this.newUserObj = {email: null, password: null, password2: null};
    this.showContinueButton = false;
    this.$tracking = TrackingService;
    this.check_policy = false;
    this.displayTOSModal = false;
    this.phone_class = "";
    var _this = this;

    console.log("global modal");
    console.dir(_this.currentUser);

    _this.SetRegistrationLazyListener = _this.$rootScope.$on("SetRegistrationLazy", function ($event, params) {
      console.log("what are the params SetRegistrationLazyListener");
      console.dir(params);
      _this.type = params.type;
      _this.destroySetRegistrationLazyListener();
    });

    if (this.currentUser) {
      if (this.$security.isUndefinedOrNull(this.currentUser.company) || this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
        this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
      } else {
        this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
      }
    }

    _this.$scope.$on("$destroy", _this.SetRegistrationLazyListener);
  }

  proceedToOtherModal() {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.globalModalType = {type: 1, name: "test"};
      jQuery("#show-application-global-modal").trigger("click");
    }, 1000);
  }

  /*
	destroySetRegistrationLazyListener(){
		var _this=this;
		console.log('destroySetRegistrationLazyListener.....');
		console.dir(_this);
		console.dir(_this.SetRegistrationLazyListener);
		_this.$scope.$on('$destroy', _this.SetRegistrationLazyListener);
	}
	*/

  uploadFiles(file, errors) {
    var _this = this;
    var fd = new FormData();
    fd.append("file", file);

    if (errors.length > 0) {
      alert("There is an issue with that image. Please choose a different one.");
      _this.$timeout(function () {
        _this.$progress.complete();
      });
      return;
    }

    if (file) {
      _this.$progress.start();

      var uploadUrlCompany = _this.$auth.getUploadUrl(_this.currentUser.company.id, file);

      _this.$http
        .post(uploadUrlCompany, fd, {
          transformRequest: angular.identity,
          headers: {
            "Content-Type": undefined,
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
        })
        .then(
          function (response) {
            var callback = response.data;

            _this.$timeout(function () {
              jQuery("#application-global-modal .modal-header button.close").trigger("click");
              _this.currentUser.company.companyLogoUri = callback.mainFile.url;
              _this.$rootScope.companyLogoUri = callback.mainFile.url;
              _this.$rootScope.imgFromProfilePage = callback.mainFile.url;
              _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
              _this.$progress.complete();
              _this.$auth.reloadCurrentUser();
              _this.$rootScope.$emit("PostEventFromModal", {});
            }, 100);

            _this.$timeout(function () {
              $("#ngProgress-container").remove();
            }, 300);
          },
          function (error) {
            console.log("error");
            console.dir(error);

            _this.$timeout(function () {
              jQuery("#application-global-modal .modal-header button.close").trigger("click");
              _this.$progress.complete();
            }, 100);
          }
        );
    }
  }

  validate() {
    var _this = this;

    if (!_this.check_policy) {
      _this.errorMessage.status = true;
      _this.errorMessage.message = "Please agree with Jobble Terms.";
      return;
    } else {
      _this.errorMessage.status = false;
    }

    if (this.phone_class === "error-with-phone") {
      _this.errorMessage.status = true;
      _this.errorMessage.message = "Please enter a 10 digit phone number";
    } else {
      _this.errorMessage.status = false;
    }
  }

  phoneChange() {
    var _this = this;
    console.log("changing phone");
    console.dir(_this.newUserObj.phoneMobile);
    console.dir(_this.phone_class);
    //if (_this.phone_number)
    if (_this.newUserObj.phoneMobile) {
      var isPhoneNumber = _this.isPhone(_this.newUserObj.phoneMobile);

      if (!isPhoneNumber) {
        _this.phone_class = "error-with-phone";
      } else {
        _this.phone_class = "";
      }
    }
  }

  isPhone(val) {
    return /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val);
  }

  lazyLogin() {
    var _this = this;
    _this.remain_loading_count++;

    console.log("lazy login??");

    _this.$auth.lazyLoginExists(_this.newUserObj).then(
      function (data) {
        console.log("after sign in");
        console.dir(data);

        if (data.statusText == "OK") {
          _this.$timeout(function () {
            _this.$rootScope.$emit("UpdateCurrentUser", {user: data.data});
            _this.currentUser = data.data;
          }, 500);

          _this.$timeout(function () {
            jQuery("#show-application-global-modal").trigger("click");
            _this.$rootScope.$emit("PostEventFromModal", {});
          }, 2000);
        } else {
          alert("error: " + data.statusText);
        }
      },
      function (data) {
        _this.$timeout(function () {
          _this.remain_loading_count++;
          jQuery("#show-application-alert").trigger("click");
          alert("there was an error :" + data);
        }, 100);
      }
    );
  }

  signInWithNewLazyReg() {
    var _this = this;

    _this.$auth.lazySignin(_this.newUserObj).then(
      function (data) {
        _this.$timeout(function () {
          _this.remain_loading_count++;
        }, 500);
        if (data.statusText == "OK") {
          _this.$timeout(function () {
            jQuery("#show-application-global-modal").trigger("click");
            _this.type = null;
            _this.currentUser = data.data;
            _this.$rootScope.$emit("UpdateCurrentUser", {user: data.data});
            console.log("new current user!");
            console.dir(_this.currentUser);
            _this.$tracking.reportUserRegistration(data.data);

            if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
              _this.$tracking.reportLazyRegDuringPost(data.data);
              _this.$tracking.reportLazySignInDuringPost(data.data);
            }
          }, 500);
          _this.$timeout(function () {
            _this.$rootScope.globalModalType = {type: 2};
            jQuery("#show-application-global-modal").trigger("click");
            _this.step = 3;
          }, 1500);
        } else {
          alert("error: " + data.statusText);
        }
      },
      function (data) {
        _this.$timeout(function () {
          _this.remain_loading_count++;
          jQuery("#show-application-alert").trigger("click");
          alert("there was an error :" + data);
        }, 100);
      }
    );
  }

  checkVerificationStatus() {
    var _this = this;

    console.log("checkVerificationStatus2.....");

    _this.remain_loading_count--;
    _this.$auth.reloadCurrentUser();

    _this.$timeout(function () {
      _this.currentUser = _this.$auth.getUserData();
    }, 1500);

    _this.$timeout(function () {
      if (_this.currentUser.isVerified) {
        _this.remain_loading_count++;
        _this.$rootScope.$emit("UpdateEventsToPublished", {});
        jQuery("#show-application-global-modal").trigger("click");
      } else {
        console.log("do i go here");
        _this.remain_loading_count++;
        //alert('Verification still pending: Please try again.');
        _this.verificationError =
          "Your email confirmation has yet to be confirmed. Please find the email titled 'Please Verify Your Email Address' and click the confirmation link inside.";
      }
    }, 2000);
  }

  parsePhone(phoneNum) {
    var phoneNumber = "1" + phoneNum;
    return phoneNumber.replace(/\D/g, "");
  }

  registerNewLazyUser() {
    var _this = this;

    _this.remain_loading_count--;
    _this.validate();

    if (_this.errorMessage.status === true) {
      _this.remain_loading_count++;
      return;
    }

    var cookies = _this.$cookies.getAll();

    var marketingParams = null;

    if (cookies.hubspotutk) {
      marketingParams = "&hubspotutk=" + cookies.hubspotutk;
    }

    _this.newUserObj.phoneMobile = _this.parsePhone(_this.newUserObj.phoneMobile);

    _this.$auth.lazyReg(_this.newUserObj, marketingParams).then(
      function (data) {
        console.log("response from registering 3");
        console.dir(data);
        if (data.data.status == "OK") {
          _this.signInWithNewLazyReg();
        } else {
          _this.$timeout(function () {
            _this.errorMessage.status = true;
            if (data.data.errors) {
              _this.errorMessage.message = data.data.errors.message;
            } else {
              if (data.data.message.indexOf("Duplicate entry") > -1) {
                _this.errorMessage.message = "This username already exists. Please try another.";
              } else {
                _this.errorMessage.message = "There was an error with your registration from the server. Please contact corey@jobbleapp.com";
              }
            }
          });
          _this.$timeout(function () {
            _this.remain_loading_count++;
          });
        }
      },
      function (data) {
        _this.$timeout(function () {
          _this.remain_loading_count++;
          console.log("what is the data");
          console.dir(data);
          jQuery("#show-application-alert").trigger("click");
          alert("there was an error2 :" + data);
        }, 100);
      }
    );
  }

  showSignInScreen() {
    var _this = this;

    if (_this.isLazyUser) {
      _this.isLazyUser = false;
    } else {
      _this.isLazyUser = true;
    }
  }

  closeTerms() {
    this.displayTOSModal = false;
  }
}

GlobalmodalController.$inject = [
  "$http",
  "$state",
  "$stateParams",
  "$scope",
  "auth",
  "events",
  "security",
  "$rootScope",
  "$localStorage",
  "ngProgressFactory",
  "$timeout",
  "$cookies",
  "tracking",
];

export default GlobalmodalController;



// WEBPACK FOOTER //
// ./client/app/common/globalmodal/globalmodal.controller.js